import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import { SHOW_NOTICE } from 'reducers/notice'

import * as ApiRouter from 'constants/apiRouting'
import { API_URL_SITE_LIST } from 'constants/index'
import {
  FETCH_LOCUS_GROUP_LIST,
  SUCCESS_LOCUS_GROUP_LIST,
  FAILURE_LOCUS_GROUP_LIST,
  LOAD_LOCUS_GROUP_LIST,
  FETCH_LOCUS_GROUP_TABLE,
  SUCCESS_LOCUS_GROUP_TABLE,
  FAILURE_LOCUS_GROUP_TABLE,
  LOAD_LOCUS_GROUP_TABLE,
  FETCH_LOCUS_GROUP_FORM,
  SUCCESS_LOCUS_GROUP_FORM,
  FAILURE_LOCUS_GROUP_FORM,
  LOAD_LOCUS_GROUP_FORM,
  SET_LOCUS_GROUP_INFO,
  DELETE_LOCUS_GROUP_INFO,
} from './reducer'

function* fetchLocusGroupList(action) {
  try {
    yield put({ type: LOAD_LOCUS_GROUP_LIST, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_GROUPS}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_GROUP_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_GROUP_LIST })
    }

    yield put({ type: LOAD_LOCUS_GROUP_LIST, payload: false })
  } catch (error) {
    console.log('LOAD LOCUS GROUP LIST ERROR', error)
  }
}

function* fetchLocusGroupTable(action) {
  try {
    yield put({ type: LOAD_LOCUS_GROUP_TABLE, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_GROUP_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_GROUP_TABLE,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_GROUP_TABLE })
    }

    yield put({ type: LOAD_LOCUS_GROUP_TABLE, payload: false })
  } catch (error) {
    console.log('LOAD LOCUS GROUP TABLE ERROR', error)
  }
}

function* fetchLocusGroupForm({ payload }) {
  try {
    yield put({ type: LOAD_LOCUS_GROUP_FORM, payload: true })

    const { entityId } = payload
    const formData = {
      sites: [],
      locusGroup: null,
    }

    formData.sites = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: API_URL_SITE_LIST,
    })

    if (entityId) {
      formData.locusGroup = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.create(ApiRouter.LOCUS_GROUP_INFO, { id: entityId }),
      })
    }

    if (
      formData.sites &&
      !formData.sites.hasOwnProperty('error') &&
      (!formData.locusGroup || !formData.locusGroup.hasOwnProperty('error'))
    ) {
      yield put({
        type: SUCCESS_LOCUS_GROUP_FORM,
        payload: formData,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_GROUP_FORM })
    }

    yield put({ type: LOAD_LOCUS_GROUP_FORM, payload: false })
  } catch (error) {
    console.log('LOAD LOCUS GROUP FORM ERROR', error)
  }
}

function* setLocusGroupInfo({ payload, promise }) {
  try {
    const { entityId, values } = payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: !entityId
        ? ApiRouter.LOCUS_GROUPS
        : UrlHelper.create(ApiRouter.LOCUS_GROUP_INFO, { id: entityId }),
      method: !entityId ? 'POST' : 'PUT',
      data: values,
    })

    if (response.error) {
      return yield call(promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Unit group ${entityId === 0 ? 'create' : 'change'} successful`,
      ),
    })

    return yield call(promise.resolve, false)
  } catch (error) {
    throw new Error(`UNKNOW UNIT GROUP CHANGE ERROR. DATA: ${error}`)
  }
}

function* deleteLocusGroupInfo(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(ApiRouter.LOCUS_GROUP_INFO, {
        id: action.payload.entityId,
      }),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Locus delete successful'),
      })

      return yield fetchLocusGroupTable(action)
    }
  } catch (error) {
    console.log('LOCUS INTERFACE ERROR', error)
  }
}

function* locusGroupSaga() {
  yield takeLatest(FETCH_LOCUS_GROUP_LIST, fetchLocusGroupList)
  yield takeLatest(FETCH_LOCUS_GROUP_TABLE, fetchLocusGroupTable)
  yield takeLatest(FETCH_LOCUS_GROUP_FORM, fetchLocusGroupForm)
  yield takeLatest(SET_LOCUS_GROUP_INFO, setLocusGroupInfo)
  yield takeLatest(DELETE_LOCUS_GROUP_INFO, deleteLocusGroupInfo)
}

export default locusGroupSaga
